import { Link } from "@tanstack/react-router";
import type { KwLink } from "@/lib/keyword-clusters";

type Props = {
  title?: string;
  links: KwLink[];
  className?: string;
};

/**
 * "Related searches on DrHint" chip grid. Renders internal-only links.
 * Used by hub / city / karat / weight / silver / UAE / Saudi pages so
 * the target keyword cluster is expressed on-page (SEO) and users get
 * one-click navigation to sibling long-tail pages.
 */
export function RelatedSearches({ title = "Related searches on DrHint", links, className = "" }: Props) {
  if (!links.length) return null;
  return (
    <section className={`mx-auto max-w-6xl px-4 py-6 ${className}`} aria-label={title}>
      <h2 className="text-base md:text-lg font-bold mb-3">{title}</h2>
      <div className="flex flex-wrap gap-2">
        {links.map((l) => (
          <Link
            key={`${l.href}-${l.label}`}
            to={l.href}
            className="inline-flex items-center rounded-full border border-border bg-card px-3 py-1.5 text-xs md:text-sm font-medium text-foreground hover:border-primary hover:bg-primary/5 transition-colors"
          >
            {l.label}
          </Link>
        ))}
      </div>
    </section>
  );
}